module.exports = __webpack_public_path__ + "img/prescription4.7e4e4d75.png";